import { SvgIcon, SvgIconProps } from '@mui/material';

export const MergeWithAllSeletedReasonSVGIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.70957 7.00094H7.99957V12.5909L3.28957 17.2909C2.89957 17.6809 2.89957 18.3109 3.28957 18.7009C3.67957 19.0909 4.30957 19.0909 4.69957 18.7009L9.40957 14.0009C9.78957 13.6209 9.99957 13.1209 9.99957 12.5909V7.00094H12.2896C12.7396 7.00094 12.9596 6.46094 12.6396 6.15094L9.34957 2.86094C9.14957 2.66094 8.83957 2.66094 8.63957 2.86094L5.34957 6.15094C5.03957 6.46094 5.25957 7.00094 5.70957 7.00094Z"
        fill="currentColor"
      />
      <path
        d="M19.5 10.5H12.5C11.95 10.5 11.5 10.95 11.5 11.5V18.5C11.5 19.05 11.95 19.5 12.5 19.5H19.5C20.05 19.5 20.5 19.05 20.5 18.5V11.5C20.5 10.95 20.05 10.5 19.5 10.5ZM15.355 17.145C15.16 17.34 14.845 17.34 14.65 17.145L12.855 15.35C12.66 15.155 12.66 14.84 12.855 14.645C13.05 14.45 13.365 14.45 13.56 14.645L15 16.085L18.44 12.645C18.635 12.45 18.95 12.45 19.145 12.645C19.34 12.84 19.34 13.155 19.145 13.35L15.355 17.145Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
